'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _reactPopper = require('react-popper'),
    _PopoverContent = require('./PopoverContent'),
    _PopoverContent2 = _interopRequireDefault(_PopoverContent),
    _PopoverTrigger = require('./PopoverTrigger'),
    _PopoverTrigger2 = _interopRequireDefault(_PopoverTrigger),
    _propTypes3 = require('../../propTypes'),
    _themes = require('../../themes'),
    _utils = require('../../utils');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  Manager: (0, _styledComponents2.default)(_reactPopper.Manager).withConfig({
    displayName: 'Popover__Manager'
  })(['display:inline-block;'])
},
    Popover = function (_Component) {
  function Popover(props) {
    _classCallCheck(this, Popover);

    var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    return _this.state = {
      open: !1
    }, _this.popoverId = (0, _utils.generateUniqueId)('popover'), _this.open = _this.open.bind(_this), _this.close = _this.close.bind(_this), _this.handleBlur = _this.handleBlur.bind(_this), _this.handleClick = _this.handleClick.bind(_this), _this.handleFocus = _this.handleFocus.bind(_this), _this.handleKeyDown = _this.handleKeyDown.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this.renderTrigger = _this.renderTrigger.bind(_this), _this;
  }

  return _inherits(Popover, _Component), _createClass(Popover, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var open = this.props.open;
      this.isControlled = void 0 !== open;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'open',
    value: function open(e) {
      var _this2 = this;

      this.focusElement = e.currentTarget, this.focusElement.focus(), this.setState({
        open: !0
      }, function () {
        document.addEventListener('keydown', _this2.handleKeyDown);
      });
    }
  }, {
    key: 'close',
    value: function close() {
      var _this3 = this,
          setFocus = 0 < arguments.length && void 0 !== arguments[0] && arguments[0];

      this.timeoutId = setTimeout(function () {
        _this3.setState({
          open: !1
        }, function () {
          document.removeEventListener('keydown', _this3.handleKeyDown), _this3.props.focusOnClose && setFocus && _this3.focusElement.focus();
        });
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.close();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      this.state.open ? this.close(!0) : this.open(e);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      event.which === 27 && this.close(!0);
    }
  }, {
    key: 'renderTrigger',
    value: function renderTrigger() {
      var _props = this.props,
          children = _props.children,
          contentIgnored = _props.content,
          focusOnCloseIgnored = _props.focusOnClose,
          openProp = _props.open,
          otherProps = _objectWithoutProperties(_props, ['children', 'content', 'focusOnClose', 'open']),
          openState = this.state.open,
          open = this.isControlled ? openProp : openState,
          child = children ? _react.Children.only(children) : void 0;

      return this.isControlled || (child = _react2.default.cloneElement(child, {
        onClick: this.handleClick
      })), _react2.default.createElement(_PopoverTrigger2.default, _extends({
        "aria-controls": this.popoverId,
        "aria-expanded": open
      }, otherProps), child);
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props2 = this.props,
          content = _props2.content,
          modifiers = _props2.modifiers,
          openProp = _props2.open,
          placement = _props2.placement,
          openState = this.state.open,
          open = this.isControlled ? openProp : openState;
      return _react2.default.createElement(_PopoverContent2.default, {
        hidden: !open,
        id: this.popoverId,
        modifiers: modifiers,
        placement: placement,
        tabIndex: -1
      }, content);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          contentIgnored = _props3.content,
          focusOnCloseIgnored = _props3.focusOnClose,
          themeIgnored = _props3.theme,
          props = _objectWithoutProperties(_props3, ['content', 'focusOnClose', 'theme']);

      return _react2.default.createElement(Styled.Manager, _extends({
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        tag: 'div'
      }, props), this.renderTrigger(), this.renderContent());
    }
  }]), Popover;
}(_react.Component);

Popover.propTypes = {
  children: _propTypes2.default.node.isRequired,
  content: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  focusOnClose: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  open: _propTypes2.default.bool,
  placement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end']),
  theme: _propTypes3.themeShape
}, Popover.defaultProps = {
  focusOnClose: !0,
  theme: (0, _themes.createTheme)()
}, Popover.displayName = 'Popover';
var PopoverWithTheme = (0, _themes.withTheme)(Popover);
PopoverWithTheme.WrappedComponent = Popover, exports.default = PopoverWithTheme;